import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
// import { useParams } from 'react-router-dom';
import api from '../services/api';
import './PageView.css';

const About = () => {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPage();
  }, []);

  const loadPage = async () => {
    try {
      const response = await api.get('/pages/about-us/');
      setPage(response.data);
    } catch (error) {
      console.error('Error loading page:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  if (!page) {
    return (
      <Container className="py-5">
        <h1>Page Not Found</h1>
      </Container>
    );
  }

  return (
    <Container className="page-view py-5">
      <h1>{page.title}</h1>
      <div className="page-content" dangerouslySetInnerHTML={{ __html: page.content }} />
    </Container>
  );
};

export default About;
